import { Col, Form, FormInstance, Input, Row } from 'antd'
import {
  useCreateLeagueSport,
  useUpdateLeagueSport,
} from 'api/Listings/LeagueSports'
import UploadDocument from 'components/global/UploadDocument'
import React, { useMemo, useState } from 'react'
import { sportCreationStore } from 'state/listing/sportListing'
import { myStore } from 'state/store'
import { Photo } from 'types/globalTypes'

interface LeagueSportFormProps {
  form: FormInstance
}

const LeagueSportForm: React.FC<LeagueSportFormProps> = ({ form }) => {
  const { sportData, setSportData, setAddSportModal } = sportCreationStore(
    store => ({
      sportData: store.sportData,
      setSportData: store.setSportData,
      setAddSportModal: store.setAddSportModal,
    }),
  )
  const [documentIds, setDocumentIds] = useState<string[]>(
    sportData ? [sportData.iconId] : [],
  )
  const [photos] = useState<Photo[]>(sportData ? [sportData.icon] : [])
  const [error, setError] = useState<string>('')
  const setModalBtnLoading = myStore(store => store.setModalBtnLoader)

  const { mutate: creatLeagueSport } = useCreateLeagueSport()
  const { mutate: updateLeagueSport } = useUpdateLeagueSport()

  const formSchema = {
    name: sportData ? sportData.name : undefined,
  }

  const onFinish = (values: { name: string }) => {
    if (documentIds.length === 0) {
      setError('Icon is required')
      return
    }

    const payload = {
      ...values,
      iconId: documentIds[0],
    }
    setModalBtnLoading(true)
    if (sportData) {
      updateLeagueSport(
        { sportId: sportData._id, payload },
        {
          onSuccess: () => {
            setModalBtnLoading(false)
            setAddSportModal(false)
          },
          onError: () => {
            setModalBtnLoading(false)
          },
        },
      )
    } else {
      creatLeagueSport(
        { payload },
        {
          onSuccess: () => {
            setModalBtnLoading(false)
            setSportData(undefined)
            setAddSportModal(false)
          },
          onError: () => {
            setModalBtnLoading(false)
          },
        },
      )
    }
  }

  useMemo(() => {
    if (documentIds.length) {
      setError('')
    }
  }, [documentIds])

  return (
    <>
      <Form
        name="league-sport-form"
        form={form}
        initialValues={formSchema}
        onFinish={onFinish}
        layout="vertical"
        autoComplete="off"
      >
        <Row>
          <Col>
            <label className="custom-field-label required-input">
              Add Icon
            </label>
          </Col>
          <Col span={12}>
            <UploadDocument
              documentIds={documentIds}
              setDocumentIds={setDocumentIds}
              multiple={true}
              docType="image/*"
              files={photos}
            />
          </Col>
          {error && (
            <Col className="-mt-20px" span={24}>
              <p className="ant-form-item-explain-error">{error}</p>
            </Col>
          )}
        </Row>
        <Row className="-mt-10px">
          <Col span={24}>
            <label className="input-label required-input">Name</label>
            <Form.Item
              colon={false}
              name="name"
              rules={[{ required: true, message: 'Name is required' }]}
            >
              <Input placeholder="Enter Name" required name="name" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  )
}

export default LeagueSportForm
